import {i18n} from "../../i18n/i18n";

import React from 'react';
import './popup.css';
import Button from '../../components/Button'
import PopupHeadingRow from '../../components/PopupHeadingRow'
import {LabelApprovalStatus} from '../../apis/labelApproval.api'

interface ImagePopupProps {
    isOpen: boolean;
    imageLink: string;
    handleCloseClick: () => void;
    onPrint?: () => void;
    onApproval?: () => void;
    /** Re-emails the existing pending request, for a lost message. */
    onResend?: () => void;
    isResending?: boolean;
    approvalStatus?: LabelApprovalStatus | null;
}

/**
 * The approval control reflects the latest request:
 *
 *  - never sent, cancelled or expired -> a plain "Approval?" button
 *  - pending                          -> the pill plus "Send again", which
 *                                        re-emails the same request (a new
 *                                        link; the record is untouched)
 *  - approved or rejected             -> the status pill plus "Send again", so
 *                                        a rejected label can be corrected and
 *                                        put back through approval
 */
const approvalText = (status?: LabelApprovalStatus | null) => {
    if (status === 'pending') return i18n('Pending')
    if (status === 'approved') return i18n('Approved')
    if (status === 'rejected') return i18n('Rejected')
    return i18n('Approval?')
}

const isResendable = (status?: LabelApprovalStatus | null) =>
    !status || status === 'cancelled' || status === 'expired'

const isAnswered = (status?: LabelApprovalStatus | null) =>
    status === 'approved' || status === 'rejected'

const ImagePopup: React.FC<ImagePopupProps> = ({
                                                   isOpen, imageLink, handleCloseClick, onPrint,
                                                   onApproval, onResend, isResending, approvalStatus
                                               }) => {
    const approvalLabel = approvalText(approvalStatus)
    return (
        <div>
            {isOpen && (
                <div className="popup-overlay">
                    <div className="popup" onClick={(e) => e.stopPropagation()}>
                        <br/>
                        <br/><br/>
                        <div className="border-2 border-solid border-gray-200 rounded-lg mb-4">
                            <img className="rounded-lg" src={imageLink} style={{maxWidth: 500, maxHeight: 500}}/>
                        </div>
                        <PopupHeadingRow
                            heading=""
                            doc='upc-error-block-warning'>
                          {
                            onApproval && (
                              isResendable(approvalStatus)
                                ? <Button
                                    text={approvalLabel}
                                    onClick={onApproval}/>
                                : <>
                                    <span className="py-2 px-5 text-sm border border-solid border-gray-300 text-secondary">
                                      {approvalLabel}
                                    </span>
                                    {isAnswered(approvalStatus) &&
                                      <Button
                                          text={i18n('Send again')}
                                          onClick={onApproval}/>
                                    }
                                    {approvalStatus === 'pending' && onResend &&
                                      <Button
                                          text={isResending ? i18n('Sending...') : i18n('Send again')}
                                          progress={isResending}
                                          onClick={onResend}/>
                                    }
                                  </>
                            )
                          }
                          {
                            onPrint &&
                              <Button
                                  text="Print"
                                  onClick={onPrint}
                              />
                          }
                            <Button
                                text={i18n("Close")}
                                onClick={handleCloseClick}/>
                        </PopupHeadingRow>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ImagePopup;
